<script>
  import ConnectWallet from './ConnectWallet.svelte';
  import { addToken } from '../../../scripts/eth';

  function addTokenApp() {
    addToken();
  } 
</script>


  <header class="sticky">
    <div class="row">
      <img class="logo" src="images/citadaoLogo.svg" alt="Logo">
      <div style="display: flex; align-items:center;">
        <a class="blue button" style="color:#FFFFFF; margin: 0px 20px;" href='https://app.citadao.io'>
          <p style="margin: 15px 20px;">Participate in IRO</p>
        </a>
        <a class="navigation-link" target="_blank" href="https://twitter.com/citadao_io"><img src="images/twitter.svg" alt="twitter" style="margin: 0px 20px;"></a>
        <a class="navigation-link" target="_blank" href="https://discord.gg/citadao"><img src="images/discord.svg" alt="discord" style="margin: 0px 40px 0px 20px;"></a>
        <ConnectWallet style="margin: 0px 20px"/>
    </div>
  </header>


<style>
  header {

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: auto;
    position: relative;

    width: auto;
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    margin: 25px 0px;
  }

  .blue {
        /* background: linear-gradient(65.76deg, #04E9F8 -32.71%, #1056D7 71.74%, #3B86FF 176.18%); */
        /* color: #1056D7; */
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    background: #1056D7;
    opacity: 0.9;
    border-radius: 6px;
    box-shadow: 2px 1000px 1px #1056D7 inset;
    display: flex; 
    flex-direction: row; 
    align-items: center; 
    justify-content: center;
    outline: none;
    }
</style>
